import { ComponentProps, forwardRef } from 'react'
import { RowBlock, type CommonBlockProps } from '../../../types'
import { Block } from '../../Block'
import { webchatClasses } from '../../../styles/classes'

type Props = RowBlock & ComponentProps<'div'> & CommonBlockProps

export const Row = forwardRef<HTMLDivElement, Props>(
  (
    {
      blocks,
      horizontalAlignment,
      verticalAlignment,
      direction,
      sender,
      timestamp,
      metadata,
      messageId,
      isReadOnly,
      sendMessage,
      ...props
    },
    ref
  ) => {
    const {
      message: {
        blocks: { row },
      },
    } = webchatClasses

    return (
      <div data-horizontal={horizontalAlignment} data-vertical={verticalAlignment} {...props} {...row} ref={ref}>
        {blocks.map((block, index) => (
          <Block key={index} block={{ ...block, direction, timestamp, sender, messageId, isReadOnly, sendMessage }} />
        ))}
      </div>
    )
  }
)

Row.displayName = 'Row'
